export const BOOKING_STATES = Object.freeze({
  happened: 'Happened',
  booked: 'Booked',
  'not-booked': 'Not booked',
  locked: 'Locked'
});
